import { ActivityResource } from "../schemas/ActivitySchemas.ts";
import type {
  ActivityExportListRequestType,
  ActivityGetListRequestType,
  ActivityType,
} from "../schemas/ActivitySchemas.ts";
import type { ReportWithDownloadV2Type } from "../schemas/ReportSchemas.ts";
import { Resources, getFilterObject } from "../util/index.ts";
import type {
  GetListResponseType,
  ResourceAdapterToAdapterQueryKeysType,
  ResourceAdapterType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export interface ActivityAdapterType
  extends Pick<ResourceAdapterType<ActivityType>, "getList" | "exportList"> {
  getList: (
    params: ActivityGetListRequestType
  ) => Promise<GetListResponseType<ActivityType>>;
  exportList: (
    params: ActivityExportListRequestType
  ) => Promise<ReportWithDownloadV2Type>;
}

export const ActivityAdapter: ActivityAdapterType = {
  /**
   * Get activity list
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/activities
   */
  getList: ({
    page,
    pageSize,
    sortBy = "timestamp",
    sortDirection = "desc",
    filters,
    meta,
  }) => {
    if (
      meta?.resourceType &&
      Object.values(ActivityResource).includes(meta?.resourceType)
    ) {
      return restAPI.nodeAPI.POST<GetListResponseType<ActivityType>>({
        endpoint: `/activities/${meta?.resourceType}/search`,
        body: {
          sort_by: sortBy,
          sort_direction: sortDirection,
          page,
          page_size: pageSize,
          filter: getFilterObject(filters),
        },
      });
    } else {
      return restAPI.nodeAPI.POST<GetListResponseType<ActivityType>>({
        endpoint: "/activities/search",
        body: {
          sort_by: sortBy,
          sort_direction: sortDirection,
          page,
          page_size: pageSize,
          filter: getFilterObject(filters),
        },
      });
    }
  },
  /**
   * Export activity logs
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/activities/export_activity_log
   */
  exportList: ({ filters, sortBy, sortDirection, meta }) => {
    return restAPI.nodeAPI.POST<ReportWithDownloadV2Type>({
      endpoint: `/activities/${meta?.resourceType}/export`,
      body: {
        sort_by: sortBy,
        sort_direction: sortDirection,
        filter: getFilterObject(filters),
      },
    });
  },
};

export const ActivityAdapterQueryKeys: ResourceAdapterToAdapterQueryKeysType<ActivityAdapterType> =
  {
    getList: (params) => [Resources.ACTIVITY, "getList", params] as const,
    exportList: (params) => [Resources.ACTIVITY, "export", params] as const,
  };
